import { Variables } from "./Variables";
import triggerIcon from "../../../../new-images/profile/trigger-icon.svg";
import triggerIconSuccess from "../../../../new-images/profile/trigger-icon-success.svg";
import successImg from "../../../../new-images/profile/success.svg";
import Selector from "../../../selector";

export const useBloodGroupVariables = (bloodoptions, value, setValue) => {

  return new Variables(
    {
      title: "Какая у вас",
      bold: " группа крови?",
      img: triggerIcon,
      prompt:
        "Укажите группу крови, чтобы мы могли оповещать вас об актуальных потребностях центров крови или адресных поисках.",
      label: "Группа крови",
      button: "Сохранить",
      htmlElement: (
        <div>
          <Selector
            placeholder={"Выберите группу крови"}
            selectorStyle={123}
            id={"bloodType"}
            options={bloodoptions}
            value={value?.label ? value : "Не указано"}
            onChange={(e) =>
              setValue((prev) => {
                let newState = { ...prev };
                newState = {
                  value: e.value,
                  label: e.label,
                };
                return newState;
              })
            }
            isSearchable={false}
            disabled={false}
          />
          {value.value === "dont_know" && (
            <p style={{ fontSize: "13px", lineHeight: "16px" }}>
              Не знаете группу крови? Не беда, её определят в центре крови.
            </p>
          )}
        </div>
      ),
    },
    {
      title: "Какая у вас группа крови?",
      img: triggerIconSuccess,
      label: "Группа крови",
      message: "Сохранено",
      succesImg: successImg,
      htmlElement: (
        <Selector
          placeholder={"Выберите группу крови"}
          selectorStyle={123}
          id={"bloodType"}
          options={bloodoptions}
          value={value}
          isSearchable={false}
          disabled={true}
        />
      ),
    }
  )
};
